import React from 'react';

import { Box, SxProps, Theme } from '@mui/material';

interface IProps {
  children?: React.ReactNode;
  dir?: string;
  index: string;
  value: string;
  sx?: SxProps<Theme>;
}

const TabPanel = React.memo((props: IProps) => {
  const { children, value, index, ...other } = props;

  return (
    <Box
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
});

export default TabPanel;
